export default [
  {
    heading: 'Home',
    acl: ['*'],
  },
  {
    title: 'Dashboard',
    acl: ['*'],
    to: { name: 'my' },
    icon: { icon: 'tabler-dashboard' },
  },
  {
    title: 'Orders',
    acl: ['*'],
    to: { name: 'my-orders' },
    icon: { icon: 'tabler-burger' },
  },
  {
    title: 'Favorites',
    acl: ['*'],
    to: { name: 'my-favorites' },
    icon: { icon: 'tabler-heart' },
  },
  {
    title: 'Payment methods',
    acl: ['*'],
    to: { name: 'my-payment-methods' },
    icon: { icon: 'tabler-cards' },
  },
]
